/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Alert, Card, CardBody, CardTitle, Col, Media, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { Spring } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons'
import { Link, Redirect } from "react-router-dom";

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
import LanguageToggle from "./selectors/language-selector";
/** End of Multiple Language imports **/

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';

import LanguageManager from '../custom-classes/language-manager';
import ApiCalls from  '../custom-classes/api-calls';
import LoaderFullWindow from './loader-windows/loader-full-window';

import ModalGeneric from './modals/modal-generic';

import SessionManager from '../custom-classes/session-manager';


// This is the item list
class Login extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });

        this.state = {
            username: "",
            password: "",
            usernameOrPasswordValid: true,
            loginError: false,
            loginErrorMessage: '',
            loading: false,
            showErrorModal: false,
            propsModal: null,
            isLoggedIn: false // to manage the login
        };
        this.props.addTranslation(global);

        // handles the username change and password
        this.handleChangeUsername = this.handleChangeUsername.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.login = this.login.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    /**
     * Call the web services to make the login
     */
    login()
    {
        if(this.state.username.length === 0 || this.state.password.length === 0) {
            this.setState({'usernameOrPasswordValid': false});
        }
        else
        {
            this.setState({loading:true});
            // Login
            ApiCalls.getLogin(this.state.username, this.state.password, (returned)=>{
                if(!returned.TransactionValid) {
                    let propsModal = {
                        bodyText: returned.Messages[0],
                        visible: true
                    };
                    this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
                }
                else
                {
                    SessionManager.setSession(returned.Token);
                    this.setState({isLoggedIn: true})
                }

            });
        }
    }

    // Handles the username change
    handleChangeUsername(event){
        this.setState({username: event.target.value}, () =>{
            this.setState({usernameOrPasswordValid: (this.state.username.length > 0 && this.state.password.length > 0)});
        });
    }

    // Handles the password change
    handleChangePassword(event){
        this.setState({password: event.target.value}, () =>{
            this.setState({usernameOrPasswordValid: (this.state.username.length > 0 && this.state.password.length > 0)});
        });
    }

    // Toggles the modal of the alert
    toggleAlertModal(){
        this.setState({showErrorModal: false});
    }

    // Renders the generic modal
    renderGenericModal(){
       return (
           <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
       );
    }

    // Renders the main form of login
    renderForm(){
         return (
            <div>
                <Col sm={{size:10, offset:1}} md={{size:10, offset:1}} lg={{size:8, offset:2}}>
                <Card>
                    <CardBody>
                        <CardTitle>
                            <FontAwesomeIcon icon={faSignInAlt} className="fa-3x"/>{' '}
                            <Translate id="login.login"/>
                        </CardTitle>
                    </CardBody>
                    <CardBody>
                        <Form>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Label for="username">
                                        <Translate id="login.username"/>
                                    </Label>
                                    <Input type="text" name="username" id="username" onChange={this.handleChangeUsername}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Label for="password">
                                        <Translate id="login.password"/>
                                    </Label>
                                    <Input type="password" name="password" id="password" onChange={this.handleChangePassword}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Alert color="danger" isOpen={!this.state.usernameOrPasswordValid}>
                                        <Translate id="login.username-password-required"/>
                                    </Alert>
                                    <Alert color="danger" isOpen={this.state.loginError}>
                                        <span>{this.state.loginErrorMessage}</span>
                                    </Alert>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Link color="link" to="/password-reset">
                                        <Translate id="login.forgot-password"/>
                                    </Link>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Button color="success" block onClick={this.login} disabled={!this.state.usernameOrPasswordValid}>
                                        <Translate id="login.log-in"/>
                                    </Button>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Link className="btn btn-block btn-info" color="link" to="/register">
                                        <Translate id="login.register"/>
                                    </Link>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                   <LanguageToggle/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
                    </Col>
            </div>
         )
    };

    // Call the item list
    render() {
        if (this.state.isLoggedIn === true)
            return (<Redirect to="/dashboard"/>);
        else {

            return (
                <div>
                    <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation}
                            config={{duration: 450, easing: Easing.linear}}>
                        {
                            styles =>
                                <div>
                                    <Col style={styles} xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                        <Media src={require('../img/user-icon-1.png')} alt="User icon" width="100%"/>
                                    </Col>
                                    <Col style={styles} sm={{size: 10, offset: 1}} lg={{size: 8, offset: 2}} md={{size: 10, offset: 1}}>
                                        {this.renderForm()}
                                    </Col>
                                    <Col style={styles} xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                        <Media style={styles} src={require('../img/logo-gs-a.png')} alt="Company logo"
                                               width="100%"/>
                                    </Col>
                                </div>
                        }
                    </Spring>
                    {this.state.loading ? <LoaderFullWindow/> : null}
                    {this.state.showErrorModal ? this.renderGenericModal() : null}
                </div>
            )
        }
    }
}

export default withLocalize(Login);


// WEBPACK FOOTER //
// ./src/components/login.js